export default [
  {
    description: `
      <ul>
        <li>Consultas médicas com preços de R$ 50,00 na 1ª consulta e R$ 87,50 nas demais consultas. Mesmo valor para clínico geral e demais áreas médicas.</li>
        <li>Descontos de até 20% em exames laboratoriais e de imagem.</li>
        <li>Desconto de até 35% em medicamentos nas redes de farmácia DrogaRaia e Drogasil.</li>
        <li>Refuturiza - plataforma de educação com mensalidade à R$14,90 e o primeiro mês gratuito.</li>
        <li>Allp Home - plano fitness Allp Home Básico gratuito por 12 meses. R$4,99 no plano Plus após o período de degustação.</li>
        <li>Possibilidade de ganhar itens ou experiências exclusivas  com seu clube de coração.</li>
      </ul>
    `,
    title: 'Quais os benefícios que o Cartão SOFT oferece?'
  },
  {
    description: `
      <p>
        Não há carteirinha. Para uso dos benefícios basta apresentar o CPF.  A carteirinha de sócio-torcedor do clube funciona como carteirinha Soft pois é um benefício acoplado ao sócio-torcedor.
      </p>
    `,
    title: 'Quando vou receber minha carteirinha?'
  },
  {
    description: '<p>O Cartão SOFT é uma assinatura individual. Não é permitido incluir dependentes.</p>',
    title: 'Quero incluir um dependente, o que devo fazer?'
  },
  {
    description: '<p>Telefone: 4003-5745.</p>',
    title: 'Qual o canal para agendamento de consultas?'
  },
  {
    description: `<p>
      Sim. No site da AmorSaúde você encontra a unidade mais próxima: <a href="https://www.amorsaude.com.br/unidades" rel="noreferrer" target="_blank">www.amorsaude.com.br/unidades</a>
    </p>
    `,
    title: 'Posso ligar diretamente para uma clínica e marcar a minha consulta?'
  },
  {
    description: '<p>Basta apresentar o CPF.</p>',
    title: 'Quais documentos preciso apresentar para agendar uma consulta?'
  },
  {
    description: '<p>Não. Os atendimentos são através de horário marcado.</p>',
    title: 'A clínica atende emergência?'
  },
  {
    description: '<p>A maioria das clínicas aceita dinheiro e cartão, mas pode variar de acordo com a localidade do paciente.</p>',
    title: 'Quais formas de pagamento são aceitas pela clínica?'
  },
  {
    description: '<p>São atendidas mais de 40 áreas médicas, entre elas Clínica Geral, Cardiologia, Ortopedia, Ginecologia, Pediatria e Oftalmologia.</p>',
    title: 'Quais especialidades são atendidas na clínica?'
  },
  {
    description: '<p>Sim, o programa Esportes Soft é aceito em todo o Brasil.</p>',
    title: 'É possível passar em consulta em uma clínica AmorSaúde de outro estado?'
  },
  {
    description: '<p>Basta apresentar o CPF no balcão da loja.</p>',
    title: 'O que preciso fazer para ter desconto nas farmácias DrogaRaia e Drogasil?'
  },
  {
    description: '<p>Após se tornar Soft, o filiado receberá um e-mail sobre a Refuturiza, onde poderá acessar o site parceiro para aceitar os termos e aproveitar um mês gratuito na plataforma de educação. Se desejar continuar após o período, pagará apenas R$14,90 mensais.</p>',
    title: 'Como faço para ter os benefícios com a Refuturiza?'
  },
  {
    description: `<p>O filiado receberá um e-mail sobre o assunto e deverá clicar no botão disponível na página, que o leva para o site parceiro, onde concluirá o processo para aproveitar gratuitamente o plano fitness Allp Home Básico por 12 meses.<p/>
    <br/>
    <p>Se desejar, após a degustação, o filiado pode continuar na Allp Home, agora pagando R$4,99 no plano Allp Home Plus.</p>`,
    title: 'Como faço para utilizar o plano Allp Home gratuitamente?'
  },
  {
    description: `<p>Após a ativação na home do site ou app do sócio torcedor do clube, o filiado ganha 1 ano de gratuidade do plano Esportes Soft.<p/>
    <br/>
    <p>Após o primeiro ano gratuito, ele escolherá se continuará ou não no programa Esportes Soft, caso opte por continuar no programa, o filiado pagará ao clube de coração o valor de R$9,90.</p>`,
    title: 'Como funciona o primeiro ano de gratuidade?'
  },
  {
    description: '<p>Torcedores que já são clientes do Cartão de TODOS, Cartão de TODOS Esportes, Tutti ou Soft Sodexo, não poderão participar do programa Esportes Soft.</p>',
    title: 'Já tenho um produto Cartão de TODOS, posso ser Esportes Soft?'
  }
]
